import {Factory} from './Factory'
import { TabFactory } from './TabFactory'
import Menu from '../EditorComponents/Carousel/Menu'

export class CarouselFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  object() {
    return {
      id: this.id('carousel'),
      slug: 'editor-carousel',
      assets: {
        phone: [],
        tablet: [],
        desktop: []
      },
      background: {
        phone: 'color',
        tablet: 'color',
        desktop: 'color'
      },
      customClasses: [],
      constantClasses: {
        phone: [],
        tablet: [],
        desktop: []
      },
      containerClasses:{
        phone: [],
        tablet: [],
        desktop:[]
      },
      sections: (new TabFactory).create(),
      name: 'Carousel',
    }
  }

  properties() {
    return {
      content: [
        {key: 'has-buttons', component:'ContentToggle', text:'has Buttons', property:'hasButtons'},
        {key: 'has-elements', component:'ContentToggle', text:'has dots', property:'hasDots'},
        {key: 'has-interval', component:'ContentToggle', text:'has interval', property:'hasInterval'},
        {key: 'interval', component:'ContentText', text:'interval', property:'interval'},
      ],
      styles: [
        {key: 'carousel-height', component:'CustomHeightProperty'},
        {key: 'carousel-margin', component:'MarginProperty'},
      ],
      buttonsStyles: [
        {key: 'background', component:'BackgroundProperty', styles:'buttonsStyles', only: ['color']},
        {key: 'rounded', component:'RoundedProperty',  class:'buttonsClasses'},
        {key: 'icon-color', component:'TextColorProperty',  styles:'buttonsStyles'},
      ],
      dotsStyles: [
        {key: 'carousel-dots', component:'CarouselDotStyleProperty', class:'dotsClasses'},
        {key: 'border', component:'BorderProperty', class: 'dotsClasses', styles:'dotsStyles', only: ['color']},
        {key: 'background', component:'BackgroundProperty', styles:'activeDotsStyles', only: ['color']},
      ],
      advanced: [
        {key: 'element-id', component: 'ElementId'},
        {key: 'custom-classes', component: 'CustomClasses'},
        {key: 'custom-styles', component: 'CustomStyles'},
      ],
      menu: Menu
    }
  }
}
